import { render } from "./AreYouSureModal.vue?vue&type=template&id=1d86ea6c"
import script from "./AreYouSureModal.vue?vue&type=script&lang=ts"
export * from "./AreYouSureModal.vue?vue&type=script&lang=ts"
script.render = render

export default script